import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 1200px;
  padding: 0 50px;
  margin: 0 auto;
  height: 60px;
  justify-content: space-between;
  background: #2f3133;
  color: white;

  @media screen and (max-width: 480px) {
    width: 100%;
    margin: 0;
    padding: 0 5px;
    font-size: 11px;
    height: 40px;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;
export const Copyright = styled.p``;
export const Middle = styled.div`
  display: flex;
  align-items: center;
`;
export const Right = styled.div`
  display: flex;
  align-items: center;
`;
export const Icon = styled.div`
  cursor: pointer;
`;
